import { z } from 'zod';
export const GoogleLoginSchema = z.object({
    accessToken: z.string().optional()
});
//# sourceMappingURL=googleLoginSchema.js.map